import React from 'react';
import { Github, Linkedin, Twitter, ArrowUpRight } from 'lucide-react';

const footerLinks = {
  Services: ['Web Development', 'Mobile Apps', 'DevOps & Cloud', 'Agentic AI', 'Generative AI'],
  Company: ['About Us', 'Portfolio', 'Process', 'Testimonials'],
  Resources: ['Blog', 'Case Studies', 'Tech Stack', 'FAQ'],
  Legal: ['Privacy Policy', 'Terms of Service', 'Cookie Policy'],
};

export default function Footer() {
  return (
    <footer style={{
      background: '#020510', borderTop: '1px solid var(--border)',
      padding: '5rem 0 2rem', position: 'relative', overflow: 'hidden',
    }}>
      <div className="glow-orb" style={{
        width: '400px', height: '200px',
        background: 'radial-gradient(circle, rgba(37,138,203,0.08) 0%, transparent 70%)',
        bottom: 0, left: '50%', transform: 'translateX(-50%)',
      }} />

      <div className="container">
        {/* CTA Banner */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(37,138,203,0.12) 0%, rgba(37,138,203,0.04) 100%)',
          border: '1px solid rgba(37,138,203,0.2)', borderRadius: '20px',
          padding: '3rem', marginBottom: '4rem',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          flexWrap: 'wrap', gap: '2rem',
        }}>
          <div>
            <h3 style={{ fontFamily: 'var(--font-display)', fontSize: '1.75rem', fontWeight: 800, marginBottom: '0.5rem' }}>
              Ready to build with <span className="gradient-text">Nuage?</span>
            </h3>
            <p style={{ color: 'var(--text-secondary)', maxWidth: '400px' }}>
              Let's engineer your next intelligent digital product together.
            </p>
          </div>
          <a href="#contact" className="btn-primary" style={{ fontSize: '1rem', padding: '1rem 2.2rem', whiteSpace: 'nowrap' }}>
            Start Free Consultation <ArrowUpRight size={18} />
          </a>
        </div>

        {/* Links */}
        <div style={{
          display: 'grid', gridTemplateColumns: '2fr repeat(4, 1fr)',
          gap: '3rem', marginBottom: '4rem',
        }} className="footer-grid">
          {/* Brand */}
          <div>
            <img src="/logo.png" alt="Nuage" style={{ height: '44px', marginBottom: '1rem' }} />
            <p style={{ fontSize: '0.88rem', color: 'var(--text-secondary)', lineHeight: 1.7, maxWidth: '240px' }}>
              Engineering intelligent digital products and AI solutions for modern businesses.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
              {[Github, Linkedin, Twitter].map((Icon, i) => (
                <a key={i} href="/" style={{
                  width: '36px', height: '36px', borderRadius: '8px',
                  background: 'rgba(37,138,203,0.08)', border: '1px solid var(--border)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: 'var(--text-secondary)', textDecoration: 'none', transition: 'all 0.2s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.color = 'var(--accent)'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--text-secondary)'; }}
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <div style={{
                fontSize: '0.75rem', fontWeight: 700, letterSpacing: '0.12em',
                textTransform: 'uppercase', color: 'var(--text-primary)', marginBottom: '1.25rem',
              }}>{title}</div>
              {links.map(link => (
                <a key={link} href="/" style={{
                  display: 'block', fontSize: '0.88rem', color: 'var(--text-muted)',
                  textDecoration: 'none', marginBottom: '0.6rem', transition: 'color 0.2s',
                }}
                  onMouseEnter={e => e.target.style.color = 'var(--accent)'}
                  onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
                >{link}</a>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: '1rem',
          paddingTop: '2rem', borderTop: '1px solid var(--border)',
        }}>
          <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)' }}>
            © {new Date().getFullYear()} Nuage Cloud & IT Consulting. All rights reserved.
          </p>
          <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)' }}>
            Built with ❤️ &amp; AI by Nuage
          </p>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 500px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}